import { render, staticRenderFns } from "./InboundList.vue?vue&type=template&id=a6fe63fa&scoped=true&"
import script from "./InboundList.vue?vue&type=script&lang=js&"
export * from "./InboundList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fe63fa",
  null
  
)

export default component.exports